document.querySelectorAll('[data-bnl-quickbuy]').forEach((quickbuy) => {
  const offerButtons = Array.from(quickbuy.querySelectorAll('[data-offer]'));
  const variantRows = Array.from(quickbuy.querySelectorAll('[data-bnl-variant-row]'));
  const selects = Array.from(quickbuy.querySelectorAll('[data-bnl-variant-select]'));
  const addButton = quickbuy.querySelector('[data-bnl-add]');
  const price = quickbuy.querySelector('[data-bnl-price]');
  const shipping = quickbuy.querySelector('[data-bnl-shipping]');
  const description = quickbuy.querySelector('[data-bnl-description]');
  const message = quickbuy.querySelector('[data-bnl-message]');
  const colorStep = quickbuy.querySelector('[data-bnl-color-step]');
  const colorPlural = quickbuy.querySelector('[data-bnl-color-plural]');
  let choosingColors = false;
  let current = quickbuy.querySelector('.bnl-quickbuy__offer.is-selected') || offerButtons[0];
  const descriptions = { starter:'', two:'', three:'' };

  const update = (button) => {
    current = button;
    offerButtons.forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-checked', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
    });
    const qty = Number(button.dataset.qty || 1);
    variantRows.forEach((row, index) => row.classList.toggle('is-hidden', index >= qty));
    choosingColors = false;
    quickbuy.classList.remove('is-choosing-colors');
    if (colorStep) colorStep.setAttribute('aria-hidden','true');
    if (colorPlural) colorPlural.textContent = qty > 1 ? 's' : '';
    if (addButton) {
      addButton.textContent = 'Add to cart';
      addButton.setAttribute('aria-expanded','false');
    }
    price.textContent = button.dataset.price || '';
    shipping.textContent = button.dataset.shipping || '';
    shipping.classList.toggle('is-free-shipping', (button.dataset.shipping || '').toUpperCase().includes('FREE'));
    description.textContent = descriptions[button.dataset.offer] || '';
    message.textContent = '';
    const offerImage = quickbuy.querySelector('[data-bnl-offer-image]');
    if (offerImage) {
      const images = { starter:offerImage.dataset.imageStarter, two:offerImage.dataset.imageTwo, three:offerImage.dataset.imageThree };
      if (images[button.dataset.offer]) offerImage.src = images[button.dataset.offer];
    }
    const batteryNote = quickbuy.querySelector('[data-bnl-battery-note]');
    if (batteryNote) {
      batteryNote.classList.remove('is-hidden');
      batteryNote.textContent = '3 AA batteries included with each Starter Pack.';
    }
  };

  const syncVariant = (select) => {
    const option = select.options[select.selectedIndex];
    const row = select.closest('[data-bnl-variant-row]');
    const thumb = row?.querySelector('[data-bnl-color-thumb]');
    const label = row?.querySelector('[data-bnl-color-label]');
    const unitColor = row?.querySelector('[data-bnl-unit-color]');
    const colorName = option?.dataset.title || option?.textContent || '';
    if (thumb && option?.dataset.image) thumb.src = option.dataset.image;
    if (label) label.textContent = colorName;
    if (unitColor) unitColor.textContent = colorName;
  };

  quickbuy.querySelectorAll('[data-bnl-color-choice]').forEach((choice) => {
    choice.addEventListener('click', () => {
      if (choice.disabled) return;
      const row = choice.closest('[data-bnl-variant-row]');
      const select = row?.querySelector('[data-bnl-variant-select]');
      if (!select) return;
      select.value = choice.dataset.bnlColorChoice;
      select.dispatchEvent(new Event('change', { bubbles:true }));
      const disclosure = row.querySelector('[data-bnl-color-select]');
      if (disclosure) disclosure.open = false;
    });
  });
  selects.forEach((select) => {
    select.addEventListener('change', () => syncVariant(select));
    syncVariant(select);
  });
  const colorZoom = quickbuy.querySelector('[data-bnl-color-zoom]');
  const colorZoomImage = quickbuy.querySelector('[data-bnl-color-zoom-image]');
  const colorZoomLabel = quickbuy.querySelector('[data-bnl-color-zoom-label]');
  let previewedChoice = null;
  let previewedSelect = null;
  const positionColorZoom = (anchor) => {
    if (!colorZoom || !anchor) return;
    const details = anchor.closest('[data-bnl-color-select]');
    const menu = details?.querySelector('.bnl-color-select__menu');
    const menuRect = (menu && details?.open ? menu : anchor).getBoundingClientRect();
    const quickbuyRect = quickbuy.getBoundingClientRect();
    const gap = 12;
    const zoomWidth = 190;
    const zoomHeight = 190;

    // Position relative to the quick-buy panel so the preview sits beside,
    // never over, the open selector list.
    let left = menuRect.right - quickbuyRect.left + gap;
    let top = menuRect.top - quickbuyRect.top;
    let renderedWidth = zoomWidth;
    let renderedHeight = zoomHeight;

    if (window.matchMedia('(max-width: 640px)').matches) {
      renderedWidth = 180;
      renderedHeight = 180;
      left = 0;
      top = 0;
    }

    const maxLeft = Math.max(0, quickbuy.clientWidth - renderedWidth);
    left = Math.min(Math.max(0, left), maxLeft);

    colorZoom.style.width = renderedWidth + 'px';
    colorZoom.style.height = renderedHeight + 'px';
    colorZoom.style.setProperty('left', left + 'px', 'important');
    colorZoom.style.setProperty('top', top + 'px', 'important');
    colorZoom.style.setProperty('right', 'auto', 'important');
    colorZoom.style.setProperty('bottom', 'auto', 'important');

    const image = colorZoom.querySelector('img');
    if (image) image.style.height = '158px';
  };

  const showColorZoom = (select, imageSrc, labelText, anchor, choice = null) => {
    const option = select?.options[select.selectedIndex];
    previewedChoice = choice;
    previewedSelect = select || null;
    const previewLabel = labelText || option?.dataset.title || option?.textContent || '';
    if (colorZoomImage) colorZoomImage.src = imageSrc || option?.dataset.image || '';
    if (colorZoomLabel) colorZoomLabel.textContent = previewLabel;
    if (colorZoom) {
      colorZoom.setAttribute('aria-hidden','false');
      colorZoom.tabIndex = 0;
      colorZoom.setAttribute('aria-label', previewLabel ? 'Choose ' + previewLabel : 'Choose this color');
    }
    quickbuy.classList.add('is-color-picking');
    requestAnimationFrame(() => positionColorZoom(anchor));
  };
  const hideColorZoom = () => {
    if (quickbuy.querySelector('[data-bnl-color-select][open]')) return;
    quickbuy.classList.remove('is-color-picking');
    previewedChoice = null;
    previewedSelect = null;
    if (colorZoom) {
      colorZoom.setAttribute('aria-hidden','true');
      colorZoom.tabIndex = -1;
    }
  };

  colorZoom?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (previewedChoice && !previewedChoice.disabled) {
      previewedChoice.click();
      return;
    }
    if (previewedSelect) {
      previewedSelect.dispatchEvent(new Event('change', { bubbles:true }));
      const disclosure = previewedSelect.closest('[data-bnl-variant-row]')?.querySelector('[data-bnl-color-select]');
      if (disclosure) disclosure.open = false;
    }
  });

  quickbuy.querySelectorAll('[data-bnl-color-select]').forEach((disclosure) => {
    const row = disclosure.closest('[data-bnl-variant-row]');
    const select = row?.querySelector('[data-bnl-variant-select]');
    disclosure.addEventListener('toggle', () => {
      if (disclosure.open) {
        quickbuy.querySelectorAll('[data-bnl-color-select][open]').forEach((other) => {
          if (other !== disclosure) other.open = false;
        });
        if (window.matchMedia('(max-width: 640px)').matches) {
          requestAnimationFrame(() => {
            const selectedId = select?.value;
            const selectedChoice = disclosure.querySelector('[data-bnl-color-choice="' + selectedId + '"]');
            selectedChoice?.scrollIntoView({ behavior:'smooth', block:'nearest', inline:'center' });
          });
        } else {
          showColorZoom(select, null, null, disclosure.querySelector('summary'));
        }
      } else {
        requestAnimationFrame(hideColorZoom);
      }
    });
    disclosure.querySelectorAll('[data-bnl-color-choice]').forEach((choice) => {
      const choiceImage = choice.querySelector('img');
      const choiceLabel = choice.querySelector('span:last-child');
      const previewChoice = () => {
        if (!window.matchMedia('(max-width: 640px)').matches) {
          showColorZoom(select, choiceImage?.src, choiceLabel?.textContent?.replace(' Sold out',''), disclosure.querySelector('summary'), choice);
        }
      };
      choice.addEventListener('mouseenter', previewChoice);
      choice.addEventListener('focus', previewChoice);
    });
  });

  offerButtons.forEach((button, index) => {
    button.addEventListener('click', () => update(button));
    button.addEventListener('keydown', (event) => {
      if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      const direction = (event.key === 'ArrowRight' || event.key === 'ArrowDown') ? 1 : -1;
      const next = offerButtons[(index + direction + offerButtons.length) % offerButtons.length];
      update(next);
      next.focus();
    });
  });
  update(current);

  addButton?.addEventListener('click', async () => {
    if (!current || !selects.length) return;
    if (!choosingColors) {
      choosingColors = true;
      quickbuy.classList.add('is-choosing-colors');
      if (colorStep) colorStep.setAttribute('aria-hidden','false');
      addButton.setAttribute('aria-expanded','true');
      addButton.textContent = 'Add to cart';
      message.textContent = '';
      requestAnimationFrame(() => colorStep?.querySelector('summary')?.focus({ preventScroll:true }));
      return;
    }
    addButton.disabled = true;
    message.textContent = '';
    try {
      const qty = Number(current.dataset.qty || 1);
      const quantities = new Map();
      selects.slice(0, qty).forEach((select) => {
        const option = select.options[select.selectedIndex];
        const id = option.dataset.starterId;
        if (!id) throw new Error('Please choose an available color.');
        quantities.set(id, (quantities.get(id) || 0) + 1);
      });
      const items = Array.from(quantities, ([id, quantity]) => ({ id:Number(id), quantity }));
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest' },
        body:JSON.stringify({ items })
      });
      const product = await response.json();
      if (!response.ok) throw product;
      const discountCode = (current.dataset.discount || '').trim();
      if (discountCode) {
        await fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(window.Shopify.routes.root + 'cart'), { credentials:'same-origin' });
      }
      addButton.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles:true, detail:{ product, addToCartBtn:addButton } }));
      message.textContent = 'Added to cart.';
    } catch (error) {
      message.textContent = error.description || error.message || String(error);
      message.setAttribute('role','alert');
    } finally {
      addButton.disabled = false;
    }
  });
});